import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { Tab, Tabs } from "@mui/material";

import { DataGrid } from "@shared/components/DataGrid";
import { NotificationSendLogsDialog } from "@modules/notifications/components";
import { CsvExportButton } from "@shared/components";

import { NOTIFICATION_TABS, useNotificationsList } from "./controller";
import { useNotificationsListColumns } from "./columns";

export const NotificationList = React.memo(() => {
  const {
    tab,
    setTab,
    rows = [],
    loading,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useNotificationsList();

  const [logsFor, setLogsFor] = React.useState<number | null>(null);
  const columns = useNotificationsListColumns({ onRefetch: refetch, onOpenLogs: setLogsFor, translate });

  return (
    <List
      title={translate("notifications_emails_admin.titles.list")}
      headerButtons={
        <>
          <CsvExportButton
            data={dataToExport}
            filename="notifications.csv"
            isLoading={loading}
            isDisabled={!rows?.length}
          />
          <CreateButton />
        </>
      }
    >
      <Tabs value={tab} onChange={(_, value) => setTab(value)} variant="scrollable" sx={{ mb: 2 }}>
        {NOTIFICATION_TABS.map((value) => (
          <Tab key={value} value={value} label={translate(`notifications_emails_admin.tabs.${value}`)} />
        ))}
      </Tabs>

      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) => setSelectedRows(selectionModel as number[])}
      />

      <NotificationSendLogsDialog notificationId={logsFor} onClose={() => setLogsFor(null)} />
    </List>
  );
});
